// extracted by mini-css-extract-plugin
export var alignCenter = "_7t-d";
export var bannerShown = "_7t-6";
export var buttonContent = "_7t-0";
export var cardList = "_7t-1";
export var centerContent = "_7t-2";
export var chevron = "_7t-3";
export var closePanelButton = "_7t-k";
export var conversationContextContainer = "_7t-l";
export var conversationDetailContainer = "_7t-4";
export var detailWrapper = "_7t-7";
export var dropdownButton = "_7t-e";
export var dropdownTitle = "_7t-9";
export var fullHeight = "_7t-5";
export var hidden = "_7t-a";
export var icon = "_7t-b";
export var mergeSuggestionWrapper = "_7t-m";
export var panel = "_7t-i";
export var portalButtonsWrapper = "_7t-c";
export var right = "_7t-j";
export var tableSummaryContainer = "_7t-8";
export var tableSummaryHeader = "_7t-g";
export var threeDotsButton = "_7t-f";
export var wide = "_7t-h";